import { render } from "./SideTemplate.vue?vue&type=template&id=6d87f664"
import script from "./SideTemplate.vue?vue&type=script&lang=js"
export * from "./SideTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script